module.exports = __webpack_public_path__ + "img/point7.6b293c65.png";